<div>
	<div class="row">
		<div class="col-lg-6 d-flex">
			<span data-testid="SUBSYS2_PLANLIST_RESULTS_TXT" class="results">
				{{collectionSize()}} {{labels().PLAN_TABLE_COMPONENT_RESULTS}}
			</span>
		</div>
	</div>
</div>

<div class="panel panel-cell panel-thead">

	<div class="row no-gutters">

		<div data-testid="SUBSYS2_PLANLIST_HEADER_PATID" class="col" [class.active]="activeColumn() === fields.patNumber">
			<sortable-header [name]="fields.patNumber" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PATIENT_ID}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_PLANID" class="col" [class.active]="activeColumn() === fields.planNumber">
			<sortable-header [name]="fields.planNumber" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_ID}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_DEVICE" class="col" [class.active]="activeColumn() === fields.device">
			<sortable-header [name]="fields.device" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_DEVICE}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_STEP" class="col" [class.active]="activeColumn() === fields.planStep">
			<sortable-header [name]="fields.planStep" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_STEP}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_TYPE" class="col" [class.active]="activeColumn() === fields.planType">
			<sortable-header [name]="fields.planType" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_TYPE}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_SCENARIO" class="col"
			[class.active]="activeColumn() === fields.isPostOperative">
			<sortable-header [name]="fields.isPostOperative" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_SCENARIO}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_SIDE" class="col" [class.active]="activeColumn() === fields.side">
			<sortable-header [name]="fields.side" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_SIDE}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_BONE" class="col" [class.active]="activeColumn() === fields.boneType">
			<sortable-header [name]="fields.boneType" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_BONE_TYPE}}
			</sortable-header>
		</div>
		@if (isTlhexUser()) {
		<div data-testid="SUBSYS2_PLANLIST_HEADER_FRAMEID" class="col"
			[class.active]="activeColumn() === fields.planFrameId">
			<sortable-header [name]="fields.planFrameId" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_FRAME_ID}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_STATUS" class="col no-link">
			{{labels().PLAN_TABLE_COMPONENT_PLAN_STATUS}}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_DAYSLEFT" class="col"
			[class.active]="activeColumn() === fields.planDaysLeft">
			<sortable-header [name]="fields.planDaysLeft" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_DAYS_LEFT}}
			</sortable-header>
		</div>
		}
		<div data-testid="SUBSYS2_PLANLIST_HEADER_UPDATEDATE" class="col"
			[class.active]="activeColumn() === fields.planModifiedDate">
			<sortable-header [name]="fields.planModifiedDate" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_MODIFICATION_DATE}}
			</sortable-header>
			<br>
			<span data-testid="SUBSYS2_PLANLIST_HEADER_FORMATDATE_TXT" class="date-format">{{ dateFormat }}</span>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_ACTIONS" class="col no-link stretch-col"
			[class.shrinked]="!isFiltersCollapsed()">
			{{labels().PLAN_TABLE_COMPONENT_ACTIONS}}
		</div>

	</div>

</div>

@for (plan of planList(); track plan.planId) {
<div class="panel panel-cell panel-tr">

	<div class="row no-gutters">

		<div data-testid="SUBSYS2_PLANLIST_CELL_PATID" class="col">
			{{plan.patientNumber}}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_PLANID" class="col">
			@if (isEditable(plan)) {
			<span class="a-link" (click)="editPlan(plan.planId!)" (keypress)="editPlan(plan.planId!)">
				{{plan.planNumber}}
			</span>
			} @else {
			{{plan.planNumber}}
			}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_DEVICE" class="col">
			{{ (plan.device! | deviceLabel | uppercase) || '--' }}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_STEP" class="col">
			{{ (plan.step! | planStepLabel) || '--' }}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_TYPE" class="col">
			{{ plan.caseType! | planTypeLabel }}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_SCENARIO" class="col">
			{{ plan.isPostOperative ? 'PostOp' : 'PreOp' }}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_SIDE" class="col">
			{{ plan.caseSide! | anatomicalSideLabel }}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_BONE" class="col">
			{{ plan.boneType! | boneTypeLabel }}
		</div>
		@if (isTlhexUser()) {
		<div data-testid="SUBSYS2_PLANLIST_CELL_FRAMEID" class="col">
			{{ plan.frameID ?? '--' }}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_STATUS" class="col">
			@let planStatus = plan.device === deviceEnum.Tlhex ? (plan.step | planStatus:plan.caseIsRevoked) : null;
			@if (planStatus) {
			<div class="d-flex justify-content-between align-items-center flex-wrap flex-column">
				<button type="button" class="btn colored-chip" [class]="statusClassEnum[planStatus]">
					{{ planStatus | planStatusLabel }}
				</button>
				@if (plan.caseIsPublished) { <img class="published-icon mt-3" alt="published icon" />}
				@else if (plan.caseIsRevoked) { <img class="revoked-icon mt-3" alt="revoked icon" /> }
			</div>
			} @else { -- }
		</div>
		<div data-testid="SUBSYS2_PLANLIST_CELL_DAYSLEFT" class="col">
			{{ plan.caseDaysLeft !== null ? plan.caseDaysLeft : '--' }}
		</div>
		}
		<div data-testid="SUBSYS2_PLANLIST_CELL_UPDATEDATE" class="col">
			{{ plan.caseModifiedDate! | convertDate:false }}
		</div>
		<div class="col stretch-col" [class.shrinked]="!isFiltersCollapsed()">
			<plan-action [plan]="plan" [isTlhexUser]="!!isTlhexUser()" />
		</div>

	</div>

</div>
}


<pagination />